import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-anfrage-dialog',
  templateUrl: './anfrage-dialog.component.html',
  styleUrls: ['./anfrage-dialog.component.scss']
})
export class AnfrageDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AnfrageDialogComponent>
  ) { }

  ngOnInit() {
  }

}
